export default __webpack_public_path__ + "static/media/furnace-repair.15c09870.jpeg";